import { render, staticRenderFns } from "./ItemsRow.vue?vue&type=template&id=3ddbf53c&scoped=true"
import script from "./ItemsRow.vue?vue&type=script&lang=js"
export * from "./ItemsRow.vue?vue&type=script&lang=js"
import style0 from "./ItemsRow.vue?vue&type=style&index=0&id=3ddbf53c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddbf53c",
  null
  
)

export default component.exports